export { default } from "./TamaraPromoSnippet.jsx";
